import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { t } from 'utils/getLiteral';
import CrudSelect from './CrudSelect';

const CrudBoolSelect = ({ options = [], ...props }) => {
    const yesNoOptions = useMemo(
        () => [
            {
                label: t('cfm_label_yes'),
                value: '1',
            },
            {
                label: t('cfm_label_no'),
                value: '0',
            },
        ],
        [],
    );
    return <CrudSelect {...props} options={yesNoOptions} />;
};

CrudBoolSelect.propTypes = {
    options: PropTypes.arrayOf(PropTypes.object),
};

export default CrudBoolSelect;
